const translations = {
  "en": {
    "Data Sources": "Data Sources",
    "Supported by": "Supported by"
  },
  "zh-tw": {
    "Data Sources": "資料來源",
    "Supported by": "資料提供："
  }
};

export default translations;
